export const SPECIAL_OFFERS_SUBDOMAINS = [
    'sylwester',
    'boze-narodzenie',
    'wakacje',
    'wielkanoc',
    'weekend',
    'ferie',
    'weekend-majowy',
    'dzieci',
    'weekend-czerwcowy',
    'promocje',
    'karnawal',
    'walentynki',
    'andrzejki',
    'narty',
    'dzien-kobiet',
] as const;

const SPECIAL_OFFERS_SUBDOMAINS_PATTERN = SPECIAL_OFFERS_SUBDOMAINS.join('|');
const BASE_DOMAINS_PATTERN =
    'nocowanie\\.pl\\.local|nocowanie\\.pl\\.testing\\.nocowanie\\.pl|nocowanie\\.pl';

export const ALLOWED_CORS_ORIGIN_REGEX = new RegExp(
    `^https?://(?:(?:${SPECIAL_OFFERS_SUBDOMAINS_PATTERN})\\.(?:${BASE_DOMAINS_PATTERN})|(?:${BASE_DOMAINS_PATTERN}))(?::[0-9]+)?$`,
);
